import BlogRichTextSection from "./BlogRichTextSection";

const BlogRichTextSectionWithProps = ({ blok }) => {
  return (
    <BlogRichTextSection id={blok.id} title={blok.title} content={blok.content} theme={blok.theme || "lightGray"} />
  );
};

export default BlogRichTextSectionWithProps;
